import React from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <header className="sticky top-0 z-50 w-full bg-[#fff] bg-opacity-50 text-[#6540b2]">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center">
            <Link
              className="text-2xl font-medium tracking-tight hover:text-[#e73e3c] transition-colors"
              to="/"
            >
              <img
                src={require("../../assets/logo/WePeWallet.png")}
                className="object-contain w-[70px]"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:block">
            <ul className="flex space-x-6">
              {["Features", "How it Work", , "Contact"].map((item) => (
                <li key={item}>
                  {/* <Link
                    to={`/${item.toLowerCase()}`}
                    className="text-[16px] font-[500] hover:text-[#e73e3c] transition-colors"
                  >
                    {item}
                  </Link> */}
                  <a
                    href={`#${item}`}
                    className="text-[16px] font-[500] hover:text-[#e73e3c] transition-colors"
                    onClick={(e) => {
                      e.preventDefault(); 
                      document
                        .getElementById(item)
                        ?.scrollIntoView({ behavior: "smooth" });
                      setIsOpen(false);
                    }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4 containerBtn">
            <Link
              to="https://play.google.com/store/apps/details?id=com.wepe.wallet"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-normal btn"
            >
              <span>Play Store</span>
            </Link>

            <Link
              to="https://apps.apple.com/us/app/wepe-wallet/id6743540668"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-normal btn"
            >
              <span>App Store</span>
            </Link>
          </div>

          {/* Mobile Navigation Toggle */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-[#6540b2] hover:text-[#e73e3c] transition-colors"
              aria-label={isOpen ? "Close menu" : "Open menu"}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden">
            <nav className="py-4">
              <ul className="space-y-2">
                {[
                  "Products",
                  "Solutions",
                  "About",
                  "Developers",
                  "Contact",
                ].map((item) => (
                  <li key={item}>
                    {/* <Link
                      href={`#/${item.toLowerCase()}`}
                      className="block py-2 text-sm font-medium hover:bg-purple-700 hover:text-white transition-colors"
                      onClick={() => setIsOpen(false)}
                    >
                      {item}
                    </Link> */}
                    <a
                      href={`#${item}`}
                      className="block py-2 text-sm font-medium hover:bg-purple-700 hover:text-white transition-colors"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default link behavior
                        document
                          .getElementById(item)
                          ?.scrollIntoView({ behavior: "smooth" });
                        setIsOpen(false);
                      }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
              <div className="mt-4 space-y-2 containerBtn">
                <button className="text-sm font-normal btn">
                  <span>Play Store</span>
                </button>
                <button className="text-sm font-normal btn">
                  <span>App Store</span>
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
